module.exports = __webpack_public_path__ + "img/vp-img.51af8ee2.png";